import Component from '@glimmer/component';

import { concat } from '@ember/helper';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import CButton from 'rise-ui/components/c-button.gjs';
import CField from 'rise-ui/components/c-field.gjs';
import CFieldHeight from 'rise-ui/components/c-field-height.gjs';
import DisplayOrElse from 'rise-ui/components/display-or-else.gjs';
import LocationMap from 'rise-ui/components/location-map.gjs';
import join from 'rise-ui/helpers/join.js';
import joinKeys from 'rise-ui/helpers/join-keys.js';
import latLng from 'rise-ui/helpers/lat-lng.js';
import linkToMapForLocation from 'rise-ui/helpers/link-to-map-for-location.js';
import or from 'rise-ui/helpers/or.js';
import string from 'rise-ui/helpers/string.js';

export default class CatalogDetailLocationComponent extends Component {
  <template>
    <div class="id-catalog-record__location">
      <div class="id-catalog-record__location-fields">
        <h4 class="c-section-title id-catalog-record__location-label">
          {{string "location-indirect-heading"}}
        </h4>
        <CFieldHeight class="id-catalog-record__field--location-name">
          <CField
            @label={{string "location-indirect-name-label"}}
            title={{@location.name}}
          >
            <LinksTo @route="location-detail" @model={{@location.id}}>
              {{@location.name}}
            </LinksTo>
          </CField>
        </CFieldHeight>
        <CFieldHeight class="id-catalog-record__field--location-description">
          <CField
            @label={{string "location-indirect-description-label"}}
            title={{or @location.description (string "location-indirect-description-empty")}}
            @value={{@location.description}}
          />
        </CFieldHeight>
        {{#let (join @location.tags) as | locationTags |}}
        <CFieldHeight class="id-catalog-record__field--location-tags">
          <CField
            @label={{string "location-tags-label"}}
            title={{or locationTags (string "location-tags-empty")}}
            @value={{locationTags}}
          />
        </CFieldHeight>
        {{/let}}
        <CFieldHeight class="id-catalog-record__field--location-parent">
          <CField
            @label={{string "location-parent-label"}}
            title={{or @location.parentLocation.name (string "location-parent-empty")}}
            @value={{@location.parentLocation.name}}
          />
        </CFieldHeight>
        {{#let (joinKeys @location.states "name") as | locationStates |}}
        <CFieldHeight class="id-catalog-record__field--states">
          <CField
            @label={{string "location-states-label"}}
            title={{or locationStates (string "location-states-empty")}}
            @value={{locationStates}}
          />
        </CFieldHeight>
        {{/let}}
        {{#let (join @location.unifiedRegions) as | unifiedRegions |}}
        <CFieldHeight class="id-catalog-record__field--unified-regions">
          <CField
            @label={{string "location-unified-regions-label"}}
            title={{or unifiedRegions (string "location-unified-regions-empty")}}
            @value={{unifiedRegions}}
          />
        </CFieldHeight>
        {{/let}}
        <CFieldHeight class="id-catalog-record__field--timezone">
          <CField
            @label={{string "location-timezone-label"}}
            title={{or @location.timezone (string "location-timezone-empty")}}
            @value={{@location.timezone}}
          />
        </CFieldHeight>
        <CFieldHeight class="id-catalog-record__field--elevation">
          <CField
            @label={{string "location-elevation-label"}}
            title={{or @location.elevation (string "location-elevation-empty")}}
            @value={{@location.elevation}}
            @empty="[ N/A ]"
          />
        </CFieldHeight>
        <CFieldHeight class="id-catalog-record__field--vertical-datum">
          <CField
            @label={{string "location-vertical-datum-label"}}
            title={{or @location.verticalDatum (string "location-vertical-datum-empty")}}
            @value={{@location.verticalDatum}}
            @empty="[ N/A ]"
          />
        </CFieldHeight>
        {{#let (latLng @location.latLng) as | latLng |}}
        <CFieldHeight class="id-catalog-record__field--coordinates">
          <CField
            @label={{string "location-coordinates-label"}}
            title={{or latLng (concat "See " (string "location-link"))}}
          >
            <DisplayOrElse @value={{latLng}}>
              See
              <LinksTo @route="location-detail" @model={{@location.id}}>
                {{string "location-link"}}
              </LinksTo>
            </DisplayOrElse>
          </CField>
        </CFieldHeight>
        {{/let}}
        <CFieldHeight class="id-catalog-record__field--horizontal-datum">
          <CField
            @label={{string "location-horizontal-datum-label"}}
            title={{or @location.horizontalDatum (string "location-horizontal-datum-empty")}}
            @value={{@location.horizontalDatum}}
            @empty="[ N/A ]"
          />
        </CFieldHeight>
      </div>
      <div class="id-catalog-record__map-container">
        {{#if @location.coordinates}}
          <LocationMap class="id-catalog-record__map" @location={{@location}} />
        {{/if}}
        <CButton
          @classMix="id-catalog-record__button--map-location"
          @linkToExternal={{linkToMapForLocation @location}}
        >
          {{string "location-map-link"}}
        </CButton>
      </div>
    </div>
  </template>
}
